export const ROLE_MODULES = {
  admin: ["*"],
  msp_owner: ["*"],
  super_admin: ["*"],

  service_manager: [
    "dashboard", "rmm", "recurring", "tickets", "clients", "users",
    "assets", "inventory", "network", "docs", "contracts", "licenses",
    "backups", "reports", "customer_success", "agents", "remediation"
  ],

  service_desk: [
    "tickets", "clients", "assets", "agents", "docs", "portal"
  ],

  technician: [
    "tickets", "assets", "inventory", "network", "agents", "remediation", "docs"
  ],

  l1_technician: [
    "tickets", "assets", "agents", "docs"
  ],

  readonly: [
    "dashboard", "tickets", "clients", "assets", "reports"
  ],

  client_user: [
    "portal", "tickets"
  ],

  end_user: [
    "employee"
  ],
};

export const ROUTE_MODULES = {
  "/": "dashboard",
  "/rmm": "rmm",
  "/recurring": "recurring",
  "/tickets": "tickets",
  "/clients": "clients",
  "/users": "users",
  "/assets": "assets",
  "/inventory": "inventory",
  "/network": "network",
  "/compliance": "compliance",
  "/security": "security",
  "/vulnerabilities": "vulnerabilities",
  "/docs": "docs",
  "/vault": "vault",
  "/contracts": "contracts",
  "/licenses": "licenses",
  "/backups": "backups",
  "/reports": "reports",
  "/exports": "exports",
  "/customer-success": "customer_success",
  "/customer-risk": "customer_risk",
  "/leakage": "leakage",
  "/opportunities": "opportunities",
  "/msp-bi": "msp_bi",
  "/storytelling": "storytelling",
  "/ai": "ai",
  "/identity": "identity",
  "/reconciliation": "reconciliation",
  "/evidence": "evidence",
  "/email": "email",
  "/mfa": "mfa",
  "/agents": "agents",
  "/remediation": "remediation",
  "/recurring-v2": "recurring_v2",
  "/portal": "portal",
  "/employee": "employee",
  "/search": "search",
};

export function canAccess(user, module) {
  if (!user) return false;
  const role = user.role || "readonly";
  const allowed = ROLE_MODULES[role] || [];
  return allowed.includes("*") || allowed.includes(module);
}

export function moduleForPath(pathname) {
  const exact = ROUTE_MODULES[pathname];
  if (exact) return exact;

  const key = Object.keys(ROUTE_MODULES)
    .filter(p => p !== "/" && pathname.startsWith(p))
    .sort((a, b) => b.length - a.length)[0];

  return key ? ROUTE_MODULES[key] : "dashboard";
}

export function firstAllowedPath(user) {
  if (!user) return "/login";
  if (canAccess(user, "employee")) return "/employee";
  if (canAccess(user, "dashboard")) return "/";
  if (canAccess(user, "tickets")) return "/tickets";
  if (canAccess(user, "portal")) return "/portal";
  if (canAccess(user, "assets")) return "/assets";
  return "/login";
}
